module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("5s6Il"))).then(() => parcelRequire('5lpsT'));